import React from 'react';

import Text from './Text';

import styled from 'styled-components';

type Props = {
  className?: string;
  label?: string;
  children: JSX.Element | string;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const Label = styled<any>(
  ({ children, label, className }: Props) =>
    (
      <div className={className}>
        <Text>{label}</Text>

        {children}
      </div> // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ) as any,
)``;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default Label as any;
